import { WtSurveyModal } from './WtSurveyModal';
import { useWtSurveyEligibility } from './useWtSurveyEligibility';

// Eligibility by page is the caller's job. Do not add a pathname check here —
// the app's basePath makes one vacuous.
export const WtSurvey = () => {
  const { isOpen, dismiss, click } = useWtSurveyEligibility();

  return <WtSurveyModal isOpen={isOpen} onDismiss={dismiss} onClickCta={click} />;
};

export default WtSurvey;
